import React from 'react'

import {
  Box,
  BorderStyle,
  Color,
  Display,
  FontWeight,
  Text,
  AlignItems,
} from '@gousto-internal/citrus-react'

import { onSpaceOrEnter } from 'utils/accessibility'

type CategoryButtonProps = {
  count: number
  id: string
  isActive: boolean
  label: string
  onClick: (id: string) => void
}

export const CategoryButton = ({ count, id, isActive, label, onClick }: CategoryButtonProps) => (
  <Box
    alignItems={AlignItems.Center}
    borderColor={Color.Primary_600}
    borderStyle={BorderStyle.Solid}
    borderBottomWidth={isActive ? 1 : 0}
    display={Display.Flex}
    flexShrink={0}
    gap={2}
    aria-pressed={isActive}
    onClick={() => onClick(id)}
    onKeyDown={onSpaceOrEnter(() => onClick(id))}
    paddingH={1}
    paddingV={2}
    role="button"
    tabIndex={0}
  >
    <Text
      color={isActive ? Color.Primary_600 : Color.NeutralGrey_900}
      fontWeight={isActive ? FontWeight.Bold : FontWeight.Normal}
      size={4}
    >
      {label}
    </Text>
    <Box
      alignItems={AlignItems.Center}
      bg={Color.NeutralGrey_100}
      borderRadius={1.5}
      display={Display.Flex}
      paddingH={1}
      paddingV={0.5}
    >
      <Text size={1}>{count}</Text>
    </Box>
  </Box>
)
